// AUTO-GENERATED — do not edit by hand.
//
// Camera slugs retired as exact duplicates of another slug, 2026-08-26.
//
// The catalog carries some models twice: once with the manufacturer embedded in
// the model name and once without ("AXIS P1487-LE" and "P1487-LE"). Because
// generateCameraSlug() always prefixes the manufacturer, those become
// /camera/axis-axis-p1487-le and /camera/axis-p1487-le — two URLs, one camera,
// byte-identical descriptions.
//
// ONLY pairs whose hfov AND resolution match exactly are listed here. 270
// further pairs share the same slug shape but disagree on specs; those are a
// catalog data conflict, not a duplicate, and are deliberately NOT merged.
//
// The surviving slug is whichever side already carries more GSC impressions,
// not whichever looks tidier: 30 of these 194 rank on the
// brand-doubled form, so a blanket "prefer the clean slug" rule would have
// redirected away the only URL that ranks.
//
// Retired slugs keep resolving in getCameraBySlug() so designer deep links and
// comparison pages still work; they are only dropped from the prerendered page
// set and the sitemap, and 301'd at the edge in public/.htaccess.
export const RETIRED_CAMERA_SLUGS: Record<string, string> = {
  "axis-p1467-le": "axis-axis-p1467-le",
  "axis-p1475-le": "axis-axis-p1475-le",
  "axis-axis-p1485-le": "axis-p1485-le",
  "axis-axis-p1487-le": "axis-p1487-le",
  "axis-axis-p1488-le": "axis-p1488-le",
  "axis-axis-m2025-le": "axis-m2025-le",
  "axis-axis-q1798-le": "axis-q1798-le",
  "axis-axis-q1805-le": "axis-q1805-le",
  "axis-axis-p3245-v": "axis-p3245-v",
  "axis-p3245-lve": "axis-axis-p3245-lve",
  "axis-p3265-v": "axis-axis-p3265-v",
  "axis-axis-p3267-lv-mk-ii": "axis-p3267-lv-mk-ii",
  "axis-p3267-lve-mk-ii": "axis-axis-p3267-lve-mk-ii",
  "axis-axis-p3268-lv": "axis-p3268-lv",
  "axis-axis-p3268-lve": "axis-p3268-lve",
  "axis-m3085-v": "axis-axis-m3085-v",
  "axis-axis-m3106-lve-mk-ii": "axis-m3106-lve-mk-ii",
  "axis-q3538-slve": "axis-axis-q3538-slve",
  "axis-axis-q6315-le": "axis-q6315-le",
  "axis-axis-m5526-e": "axis-m5526-e",
  "axis-axis-p1375-mk-ii": "axis-p1375-mk-ii",
  "axis-axis-p1375-e-mk-ii": "axis-p1375-e-mk-ii",
  "axis-axis-q1798-le-mk-ii": "axis-q1798-le-mk-ii",
  "axis-axis-p1378-mk-ii": "axis-p1378-mk-ii",
  "axis-axis-p1385-e-mk-ii": "axis-p1385-e-mk-ii",
  "axis-axis-m3106-l-mk-ii": "axis-m3106-l-mk-ii",
  "axis-axis-q3517-lv-mk-ii": "axis-q3517-lv-mk-ii",
  "axis-axis-q6135-le": "axis-q6135-le",
  "axis-axis-q1806-le": "axis-q1806-le",
  "axis-axis-q3626-ve": "axis-q3626-ve",
  "axis-axis-q3628-ve": "axis-q3628-ve",
  "axis-m3064-v": "axis-axis-m3064-v",
  "axis-m4318-plve": "axis-axis-m4318-plve",
  "axis-axis-q1800-le": "axis-q1800-le",
  "axis-axis-q9307-lv": "axis-q9307-lv",
  "axis-axis-p3265-lve-3": "axis-p3265-lve-3",
  "acti-acti-a213": "acti-a213",
  "acti-acti-a29": "acti-a29",
  "acti-a313": "acti-acti-a313",
  "acti-a314": "acti-acti-a314",
  "acti-acti-a410": "acti-a410",
  "acti-acti-a415": "acti-a415",
  "acti-acti-a416": "acti-a416",
  "acti-a422": "acti-acti-a422",
  "acti-acti-a423": "acti-a423",
  "acti-acti-a425": "acti-a425",
  "acti-acti-a426": "acti-a426",
  "acti-acti-a427": "acti-a427",
  "acti-acti-a428": "acti-a428",
  "acti-acti-a76": "acti-a76",
  "acti-acti-a77": "acti-a77",
  "acti-acti-a811": "acti-a811",
  "acti-acti-a820": "acti-a820",
  "acti-acti-a826": "acti-a826",
  "acti-acti-a85": "acti-a85",
  "acti-acti-a86": "acti-a86",
  "acti-acti-a912": "acti-a912",
  "acti-acti-a955": "acti-a955",
  "acti-acti-a956": "acti-a956",
  "acti-acti-a967": "acti-a967",
  "acti-acti-b419": "acti-b419",
  "acti-acti-b911": "acti-b911",
  "acti-acti-b928": "acti-b928",
  "acti-acti-e13a": "acti-e13a",
  "acti-acti-e217": "acti-e217",
  "acti-acti-e54": "acti-e54",
  "acti-acti-e618": "acti-e618",
  "acti-acti-e933": "acti-e933",
  "acti-acti-e933m": "acti-e933m",
  "acti-acti-e936": "acti-e936",
  "acti-acti-e936m": "acti-e936m",
  "acti-acti-i42": "acti-i42",
  "acti-acti-i47": "acti-i47",
  "acti-acti-kcm-7311": "acti-kcm-7311",
  "acti-acti-q115": "acti-q115",
  "acti-acti-q12": "acti-q12",
  "acti-acti-q22": "acti-q22",
  "acti-acti-q550": "acti-q550",
  "acti-acti-q711": "acti-q711",
  "acti-acti-q970": "acti-q970",
  "acti-acti-z310": "acti-z310",
  "acti-acti-z315": "acti-z315",
  "acti-acti-z316": "acti-z316",
  "acti-acti-z317": "acti-z317",
  "acti-acti-z319": "acti-z319",
  "acti-acti-z322": "acti-z322",
  "acti-acti-z324": "acti-z324",
  "acti-acti-z41": "acti-z41",
  "acti-acti-z411": "acti-z411",
  "acti-acti-z412": "acti-z412",
  "acti-acti-z415": "acti-z415",
  "acti-acti-z416": "acti-z416",
  "acti-acti-z419": "acti-z419",
  "acti-acti-z47": "acti-z47",
  "acti-acti-z49": "acti-z49",
  "acti-acti-z53": "acti-z53",
  "acti-acti-z54": "acti-z54",
  "acti-acti-z714": "acti-z714",
  "acti-acti-z72": "acti-z72",
  "acti-z721": "acti-acti-z721",
  "acti-acti-z722": "acti-z722",
  "acti-acti-z724": "acti-z724",
  "acti-acti-z78": "acti-z78",
  "acti-acti-z79": "acti-z79",
  "acti-acti-z81": "acti-z81",
  "acti-acti-z810": "acti-z810",
  "acti-acti-z812": "acti-z812",
  "acti-acti-z813": "acti-z813",
  "acti-acti-z814": "acti-z814",
  "acti-acti-z82": "acti-z82",
  "acti-acti-z86": "acti-z86",
  "acti-acti-z87": "acti-z87",
  "acti-acti-z91": "acti-z91",
  "acti-acti-z910": "acti-z910",
  "acti-acti-z911": "acti-z911",
  "acti-acti-z912": "acti-z912",
  "acti-acti-z914": "acti-z914",
  "acti-acti-z957": "acti-z957",
  "acti-acti-z958": "acti-z958",
  "acti-acti-z972": "acti-z972",
  "reolink-argus-magicam": "reolink-reolink-argus-magicam",
  "reolink-reolink-duo-2-lte": "reolink-duo-2-lte",
  "reolink-reolink-go-pt-s-lite": "reolink-go-pt-s-lite",
  "reolink-lumus-pro": "reolink-reolink-lumus-pro",
  "reolink-rlc-823s1w": "reolink-reolink-rlc-823s1w",
  "reolink-reolink-rlc-843wa": "reolink-rlc-843wa",
  "reolink-reolink-trackmix-lte-c": "reolink-trackmix-lte-c",
  "reolink-reolink-duo-4g": "reolink-duo-4g",
  "reolink-rlc-820a": "reolink-reolink-rlc-820a",
  "reolink-rlc-1240a": "reolink-reolink-rlc-1240a",
  "reolink-rlc-1224a": "reolink-reolink-rlc-1224a",
  "reolink-rlc-833a": "reolink-reolink-rlc-833a",
  "reolink-reolink-rlc-540a": "reolink-rlc-540a",
  "reolink-rlc-823s1": "reolink-reolink-rlc-823s1",
  "verkada-verkada-cd51": "verkada-cd51",
  "verkada-verkada-cd51-e": "verkada-cd51-e",
  "verkada-verkada-cb51-e": "verkada-cb51-e",
  "rhombus-rhombus-r360": "rhombus-r360",
  "rhombus-rhombus-r400": "rhombus-r400",
  "rhombus-rhombus-r500": "rhombus-r500",
  "rhombus-r540": "rhombus-rhombus-r540",
  "rhombus-rhombus-r545": "rhombus-r545",
  "march-networks-march-networks-me4-ir-micdome-4mm": "march-networks-me4-ir-micdome-4mm",
  "provision-isr-provision-isr-di-340ipsn-mvf-v2": "provision-isr-di-340ipsn-mvf-v2",
  "provision-isr-provision-isr-i4-340ipsn-mvf-v2": "provision-isr-i4-340ipsn-mvf-v2",
  "provision-isr-provision-isr-i4-340ipen-mvf": "provision-isr-i4-340ipen-mvf",
  "provision-isr-provision-isr-dh-340ipsn-mvf": "provision-isr-dh-340ipsn-mvf",
  "provision-isr-provision-isr-di-380ipen-mvf-v3": "provision-isr-di-380ipen-mvf-v3",
  "provision-isr-provision-isr-i6-380ipen-mvf-v3": "provision-isr-i6-380ipen-mvf-v3",
  "provision-isr-provision-isr-dai-380ipen-mvf-v3": "provision-isr-dai-380ipen-mvf-v3",
  "provision-isr-provision-isr-i4-320ipsn-vf-v4": "provision-isr-i4-320ipsn-vf-v4",
  "provision-isr-provision-isr-i4-320ipen-36": "provision-isr-i4-320ipen-36",
  "provision-isr-provision-isr-z4-25ipen-2-ir": "provision-isr-z4-25ipen-2-ir",
  "provision-isr-provision-isr-z1-3ipsn-4-ir": "provision-isr-z1-3ipsn-4-ir",
  "hilook-hilook-ipc-b620ha-lzu": "hilook-ipc-b620ha-lzu",
  "hilook-ipc-b640ha-lzu": "hilook-hilook-ipc-b640ha-lzu",
  "hilook-hilook-ipc-b660ha-lzu": "hilook-ipc-b660ha-lzu",
  "hilook-hilook-ipc-d640ha-lzu": "hilook-ipc-d640ha-lzu",
  "hilook-hilook-ipc-t640ha-z": "hilook-ipc-t640ha-z",
  "ezviz-ezviz-h5-poe-2k": "ezviz-h5-poe-2k",
  "kenik-kenik-kg-5430tas-ild-2-8mm": "kenik-kg-5430tas-ild-2-8mm",
  "kenik-kenik-kg-5430tas-ilcd-2-8mm": "kenik-kg-5430tas-ilcd-2-8mm",
  "kenik-kenik-kg-530dpa-l-2-8mm": "kenik-kg-530dpa-l-2-8mm",
  "amcrest-amcrest-ip8m-2496ew-v2": "amcrest-ip8m-2496ew-v2",
  "amcrest-amcrest-ip5m-t1179eb": "amcrest-ip5m-t1179eb",
  "amcrest-amcrest-ip5m-t1179ew": "amcrest-ip5m-t1179ew",
  "amcrest-ip5m-t1179eb-ai-v3": "amcrest-amcrest-ip5m-t1179eb-ai-v3",
  "amcrest-amcrest-ip5m-t1179ew-ai-v3": "amcrest-ip5m-t1179ew-ai-v3",
  "amcrest-amcrest-ip5m-t1277eb-ai": "amcrest-ip5m-t1277eb-ai",
  "amcrest-amcrest-ip5m-t1277ew-ai": "amcrest-ip5m-t1277ew-ai",
  "amcrest-amcrest-ip5m-d1188eb": "amcrest-ip5m-d1188eb",
  "amcrest-amcrest-ip5m-d1188ew": "amcrest-ip5m-d1188ew",
  "amcrest-amcrest-ip2m-852eb": "amcrest-ip2m-852eb",
  "amcrest-amcrest-ip2m-852ew": "amcrest-ip2m-852ew",
  "swann-swann-swpro-4kmsb": "swann-swpro-4kmsb",
  "geovision-geovision-gv-ebd4813": "geovision-gv-ebd4813",
  "geovision-geovision-gv-ebd8800": "geovision-gv-ebd8800",
  "geovision-geovision-gv-ebd8813": "geovision-gv-ebd8813",
  "geovision-geovision-gv-tbl8804": "geovision-gv-tbl8804",
  "geovision-gv-tbl8810": "geovision-geovision-gv-tbl8810",
  "geovision-geovision-gv-tvd8810": "geovision-gv-tvd8810",
  "geovision-geovision-gv-tvd4810": "geovision-gv-tvd4810",
  "geovision-geovision-gv-tdr4803": "geovision-gv-tdr4803",
  "geovision-geovision-gv-ebfc5800": "geovision-gv-ebfc5800",
  "ic-realtime-ipfx-b80v-irw3": "ic-realtime-ic-realtime-ipfx-b80v-irw3",
  "truen-tn-b3204u6r": "truen-truen-tn-b3204u6r",
  "truen-truen-tn-b3218k6r": "truen-tn-b3218k6r",
  "synology-synology-bc500": "synology-bc500",
  "synology-synology-cc400w": "synology-cc400w",
  "synology-synology-tc500": "synology-tc500",
  "empire-tech-empire-tech-ipc-t58ir-ze-s3": "empire-tech-ipc-t58ir-ze-s3",
  "empire-tech-ipc-b28ir-zas-s3": "empire-tech-empire-tech-ipc-b28ir-zas-s3",
  "empire-tech-ipc-b54ir-ze-s3": "empire-tech-empire-tech-ipc-b54ir-ze-s3",
  "empire-tech-ipc-b24ir-zas-s3": "empire-tech-empire-tech-ipc-b24ir-zas-s3"
};

export const RETIRED_CAMERA_SLUG_SET: ReadonlySet<string> = new Set(
  Object.keys(RETIRED_CAMERA_SLUGS),
);
